import React, { useState } from "react";
import { MdDeleteForever, MdEdit } from "react-icons/md";

const Note = ({ id, text, date, handleDeleteNote, handleEditNote }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedText, setEditedText] = useState(text);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    handleEditNote(id, editedText);
    setIsEditing(false);
  };

  return (
    <div className={`note ${isEditing ? "editing" : ""}`}>
      {isEditing ? (
        <textarea
          rows="8"
          cols="10"
          autoFocus // Add the autoFocus attribute to give focus
          value={editedText}
          onChange={(e) => setEditedText(e.target.value)}
          style={{
            color: "white", // Set the color to match the text color
            backgroundColor: "transparent", // Set the background color
            border: "none", // Set a border to match the style
          }}
        />
      ) : (
        <span>{text}</span>
      )}
      <div className="note-footer">
        <small>{date}</small>
        <div style={{ display: "flex" }}>
          {isEditing ? (
            <button className="save-note" onClick={handleSaveClick}>
              <i size="1.2em" class="uil uil-check-circle logo"></i>
            </button>
          ) : (
            <button className="edit-icon " onClick={handleEditClick}>
              <MdEdit size="1.2em" />
            </button>
          )}
          <MdDeleteForever
            className="delete-icon"
            size="1em"
            onClick={() => handleDeleteNote(id)}
          />
        </div>
      </div>
    </div>
  );
};

export default Note;
